export default [
  {
    id: 'CSH',
    name: 'Contado'
  },
  {
    id: 'CDT',
    name: 'Crédito'
  },
  {
    id: 'FOC',
    name: 'Sin costo'
  }
]
